import { useCallback } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';

//@ts-expect-error Could not find declaration file for module
import upworkLogoUrl from 'bender-url!../../../../images/logo-upwork.png';
import UsageTracker from '../../../utils/UsageTracker';
import { cleanTrackingProps } from '../../../utils/awardTrackingUtils';
import { useSendToUpwork } from '../upworkQueries';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SendToUpwork = ({
  trackId,
  trackName
}) => {
  const {
    sendToUpwork,
    sendToUpworkLoading,
    sendToUpworkError,
    sentToUpworkAlready
  } = useSendToUpwork({
    trackId
  });
  const onAddToUpwork = useCallback(() => {
    try {
      sendToUpwork().catch(Raven.captureException.bind(Raven));
      UsageTracker.trackStandalone('Award Interaction', cleanTrackingProps({
        action: 'send-to-upwork',
        type: 'certification',
        name: trackName !== null && trackName !== void 0 ? trackName : '',
        trackId: trackId.toString(),
        trackName
      }));
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }, [sendToUpwork, trackName, trackId]);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    gap: "600",
    children: [/*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(Image, {
        src: upworkLogoUrl
      })
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.upwork.gotUpwork"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "learningCenter.upwork.addToUpworkStepOne"
        })
      }), sendToUpworkLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
        label: I18n.text('learningCenter.upwork.addToUpworkStepTwoSending'),
        margin: "0",
        showLabel: true,
        size: "xs"
      }) : sendToUpworkError ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.upwork.addToUpworkStepTwoError",
        options: {
          link: /*#__PURE__*/_jsx(Button, {
            onClick: onAddToUpwork,
            use: "link",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.upwork.addToUpworkStepTwoErrorLink"
            })
          })
        }
      }) : sentToUpworkAlready ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.upwork.addToUpworkStepTwoSent"
      }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "learningCenter.upwork.addToUpworkStepTwo",
        options: {
          link: /*#__PURE__*/_jsx(Button, {
            onClick: onAddToUpwork,
            use: "link",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.upwork.addToUpworkStepTwoLink"
            })
          })
        }
      })]
    })]
  });
};